import { signInWithEmailAndPassword } from "firebase/auth";
import {
  useContext,
  createContext,
  useEffect,
  useState,
  Dispatch,
  SetStateAction,
} from "react";

import { auth } from "../../lib";

import { useUser } from "../../services";
import { DocumentData } from "firebase/firestore";

type Props = {
  children?: JSX.Element | JSX.Element[] | string;
};

interface TodoContextType {
  user: DocumentData | undefined;
  setUser: Dispatch<SetStateAction<DocumentData | undefined>>;
  signUser: (props: createUser) => Promise<string>;
}

type createUser = {
  name?: string;
  email: string;
  senha: string;
};

const AuthContext = createContext<TodoContextType | null>(null);

export const AuthProvider = ({ children }: Props) => {
  const [user, setUser] = useState<DocumentData | undefined>([]);
  const { data, getUser } = useUser();

  useEffect(() => {
    const userStorage = localStorage.getItem("authToken");

    if (userStorage === null) {
      setUser(undefined);
    }
  }, []);

  const signUser = async (props: createUser): Promise<string> => {
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        props.email,
        props.senha
      );
      const uid = userCredential.user.uid;
      getUser(uid);
      setUser(data);

      localStorage.setItem("authToken", uid);

      return "Conexão efeituada com sucesso!";
    } catch (error) {
      const errorCode = error;
      const errorMessage = error;
      console.log(error);
      throw errorMessage;
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, signUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
